var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.001 0.75C12.6293 0.75 14.751 2.8462 14.751 5.36585C14.751 7.88551 12.6293 9.98171 10.001 9.98171C7.37262 9.98171 5.25098 7.88551 5.25098 5.36585C5.25098 2.8462 7.37262 0.75 10.001 0.75Z",
  stroke: "#989AA1",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3994 12.5693L12.3994 12.5693L12.4046 12.5676C14.344 11.9441 16.4414 12.4703 17.7012 13.9463C18.6686 15.1113 19.25 16.6008 19.25 18.1951C19.25 18.7635 18.7784 19.25 18.15 19.25H1.85C1.22165 19.25 0.75 18.7635 0.75 18.1951C0.75 16.5997 1.33216 15.1092 2.30084 13.9439C3.53234 12.474 5.65119 11.9426 7.59544 12.5676L7.60058 12.5693C8.36678 12.8095 9.16743 12.9451 10 12.9451C10.8326 12.9451 11.6332 12.8095 12.3994 12.5693Z",
  stroke: "#989AA1",
  strokeWidth: 1.5
});

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.374505c5.svg";
export { ForwardRef as ReactComponent };